import { trigger } from '../helpers/event';
import { loadScript } from '../helpers/loader';

import './shared/OnDocLoad';

import LiteEvents from './LiteEvents';
import Viewport from './Viewport';
import ScrollTo from './ScrollTo';
import Header from './Header';
import Toggle from './Toggle';
import ToggleButton from './ToggleButton';
import ToggleOutside from './ToggleOutside';
import ToggleScrollEnter from './ToggleScrollEnter';
import ScrollEnter from './ScrollEnter';
import CountUp from './CountUp';
import Listing from './Listing';
import ShowMoreGridAndFiltration from './ShowMoreGridAndFiltration';
import SmoothScroll from './SmoothScroll';
import ToggleContainer from './ToggleContainer';
import ScrollTiles from './ScrollTiles';
import CustomScrollbar from './CustomScrollbar';
import InteractiveMap from './InteractiveMap';
import Weather from './Weather';
import ScrollToPosts from './ScrollToPosts';

class Core {
  constructor() {
    if (window.__coreInstance) {
      return window.__coreInstance;
    }

    window.triggerEvent = trigger;

    new LiteEvents();
    new Viewport();
    new ScrollTo();
    new Header();
    new Toggle();
    new ToggleButton();
    new ToggleOutside();
    new ToggleScrollEnter();
    new ToggleContainer();
    new ScrollEnter();
    new CountUp();
    new Listing();
    new ShowMoreGridAndFiltration();
    new SmoothScroll();
    new ScrollTiles();
    new CustomScrollbar();
    new InteractiveMap();
    new Weather();
    new ScrollToPosts();

    loadScript('[data-basic-slider]', () => import('./BasicSlider'));

    window.__coreInstance = this;
  }
}

export default Core;

if (!window.__coreInstance) {
  new Core();
}
